// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as ComoFuncionaRouteImport } from './routes/como-funciona'
import { Route as ContatoRouteImport } from './routes/contato'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MetodologiaRouteImport } from './routes/metodologia'
import { Route as PrivacidadeRouteImport } from './routes/privacidade'
import { Route as RecursosRouteImport } from './routes/recursos'
import { Route as SobreRouteImport } from './routes/sobre'
import { Route as TermosRouteImport } from './routes/termos'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as CasosDeUsoIndexRouteImport } from './routes/casos-de-uso.index'
import { Route as CasosDeUsoSlugRouteImport } from './routes/casos-de-uso.$slug'
import { Route as GuiasIndexRouteImport } from './routes/guias.index'
import { Route as GuiasSlugRouteImport } from './routes/guias.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const ComoFuncionaRoute = ComoFuncionaRouteImport.update({
            id: '/como-funciona',path: '/como-funciona',getParentRoute: () => rootRouteImport
          })
const ContatoRoute = ContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MetodologiaRoute = MetodologiaRouteImport.update({
            id: '/metodologia',path: '/metodologia',getParentRoute: () => rootRouteImport
          })
const PrivacidadeRoute = PrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => rootRouteImport
          })
const RecursosRoute = RecursosRouteImport.update({
            id: '/recursos',path: '/recursos',getParentRoute: () => rootRouteImport
          })
const SobreRoute = SobreRouteImport.update({
            id: '/sobre',path: '/sobre',getParentRoute: () => rootRouteImport
          })
const TermosRoute = TermosRouteImport.update({
            id: '/termos',path: '/termos',getParentRoute: () => rootRouteImport
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const CasosDeUsoIndexRoute = CasosDeUsoIndexRouteImport.update({
            id: '/casos-de-uso/',path: '/casos-de-uso/',getParentRoute: () => rootRouteImport
          })
const CasosDeUsoSlugRoute = CasosDeUsoSlugRouteImport.update({
            id: '/casos-de-uso/$slug',path: '/casos-de-uso/$slug',getParentRoute: () => rootRouteImport
          })
const GuiasIndexRoute = GuiasIndexRouteImport.update({
            id: '/guias/',path: '/guias/',getParentRoute: () => rootRouteImport
          })
const GuiasSlugRoute = GuiasSlugRouteImport.update({
            id: '/guias/$slug',path: '/guias/$slug',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,ComoFuncionaRoute: ComoFuncionaRoute,ContatoRoute: ContatoRoute,LoginRoute: LoginRoute,MetodologiaRoute: MetodologiaRoute,PrivacidadeRoute: PrivacidadeRoute,RecursosRoute: RecursosRoute,SobreRoute: SobreRoute,TermosRoute: TermosRoute,CasosDeUsoSlugRoute: CasosDeUsoSlugRoute,GuiasSlugRoute: GuiasSlugRoute,CasosDeUsoIndexRoute: CasosDeUsoIndexRoute,GuiasIndexRoute: GuiasIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)